require('./helpers/bundle-manifest').register(JSON.parse("{\"auyDg\":\"index.ce297bb8.js\",\"kzix6\":\"rollincat_logo.dcc9f8ff.png\"}"));